import { trackEvent } from "./track";

export const WHATSAPP_URL =
  "https://wa.me/919989759719?text=" +
  encodeURIComponent(
    "Hello, I would like to enquire about Dr. Santhisree Bheesetti's USA consultation appointments."
  );

export const scrollToId = (id, label) => {
  if (label) trackEvent("CTAClick", { label });
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const trackWhatsAppClick = (where) => trackEvent("WhatsAppClick", { label: where });

export const PACKAGES = {
  p350: "$350 Samyak — Nadi Pariksha",
  p600: "$600 Medha — Nadi Pariksha + 11 Brain Systems",
  p1000: "$1,000 Samanvaya — Complete Brain & Marma Program",
  unsure: "Not Sure — Please Guide Me",
};
